import * as actionTypes from "../actionTypes";

export const getDailyDarshan = payload => ({
    type: actionTypes.GET_DAILY_DARSHAN, payload
});

export const setDailyDarshan = payload => ({
    type: actionTypes.SET_DAILY_DARSHAN, payload
});

export const createDailyDarshan = payload => ({
    type: actionTypes.CREATE_DAILY_DARSHAN, payload
});

export const updateDailyDarshan = payload => ({
    type: actionTypes.UPDATE_DAILY_DARSHAN, payload
});

export const deleteDailyDarshan = payload => ({
    type: actionTypes.DELETE_DAILY_DARSHAN, payload
});

export const changeDailyDarshanStatus = payload => ({
    type: actionTypes.CHANGE_DAILY_DARSHAN_STATUS, payload
});

export const getConsultant = payload => ({
    type: actionTypes.GET_CONSULTANT_DATA, payload
})